import M from 'messages';
import WinesService from 'services/winesService';
import baseTableOptions from '../config/config';

const { colorGroup } = baseTableOptions;

const colorFilterOptions = colorGroup.fields.map(f => ({
  value: f.value,
  title: M.get(f.label),
}));

const adaptWineLibraryProducerFilterOptions = data =>
  (data?.producers || []).map(p => ({ value: p, title: p, label: p }));

const adaptWineLibraryCountryFilterOptions = data =>
  (data?.countries || []).map(c => ({ value: c.id, title: c.name, label: c.name }));

const adaptWineLibraryRegionFilterOptions = data => (data?.regions || []).map(r => ({ value: r, title: r, label: r }));

const adaptWineLibraryTypeFilterOptions = data =>
  (data?.types || []).map(t => ({ value: t.id, title: t.name, label: t.name }));

/** Partner wine library browse: fixed columns + filters aligned with those columns */
const wineLibraryBrowse = {
  fields: [
    {
      id: 'producer',
      label: 'menuItem.producer',
      type: 'text',
      sortable: true,
      width: '18%',
    },
    {
      id: 'name',
      label: 'menuItem.name',
      type: 'text',
      sortable: true,
      width: '22%',
    },
    {
      id: 'country',
      orderField: 'include_countries_name',
      label: 'table.sp.country',
      type: 'text',
      sortable: true,
      width: '14%',
    },
    {
      id: 'year',
      label: 'menuItem.year',
      type: 'text',
      sortable: true,
      width: '10%',
    },
    {
      id: 'color',
      label: 'menuItem.color',
      type: 'text',
      sortable: true,
      width: '12%',
    },
    {
      id: 'isSuperVino',
      label: 'table.wineListWines.isSuperVino',
      type: 'bool',
      showIcon: false,
      sortable: true,
      width: '10%',
    },
  ],
  rowsPerPageOptions: [5, 10, 25, 50, 100],
  filterFields: [
    {
      id: 'producer_in',
      label: 'menuItem.producer',
      type: 'custom-multi-autocomplete',
      options: () => WinesService.getWineLibraryProducerOptions(),
      adapterCallback: adaptWineLibraryProducerFilterOptions,
      withoutParams: true,
      optionsType: 'string',
      priority: 4,
      optionsWithCheckbox: true,
      selectedClassName: 'colorizeSelected',
      sortBySelected: true,
    },
    {
      id: 'countryId_in',
      label: 'table.sp.country',
      type: 'custom-multi-autocomplete',
      options: () => WinesService.getWineLibraryCountryOptions(),
      adapterCallback: adaptWineLibraryCountryFilterOptions,
      withoutParams: true,
      priority: 5,
      optionsWithCheckbox: true,
      selectedClassName: 'colorizeSelected',
      sortBySelected: true,
    },
    {
      id: 'region_in',
      label: 'menuItem.region',
      type: 'custom-multi-autocomplete',
      options: () => WinesService.getWineLibraryRegionOptions(),
      adapterCallback: adaptWineLibraryRegionFilterOptions,
      withoutParams: true,
      optionsType: 'string',
      priority: 6,
      optionsWithCheckbox: true,
      selectedClassName: 'colorizeSelected',
      sortBySelected: true,
    },
    {
      id: 'year',
      label: 'menuItem.year',
      type: 'numberRange',
      priority: 3,
    },
    {
      id: 'color_in',
      label: 'menuItem.color',
      type: 'custom-multi-autocomplete',
      options: colorFilterOptions,
      priority: 1,
      optionsWithCheckbox: true,
      selectedClassName: 'colorizeSelected',
    },
    {
      id: 'typeId_in',
      label: 'menuItem.wineType',
      type: 'custom-multi-autocomplete',
      options: () => WinesService.getWineLibraryTypeOptions(),
      adapterCallback: adaptWineLibraryTypeFilterOptions,
      withoutParams: true,
      priority: 2,
      optionsWithCheckbox: true,
      selectedClassName: 'colorizeSelected',
      sortBySelected: true,
    },
  ],
  searchFields: ['name'],
};

export default { wineLibraryBrowse };
